/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-05-05 11:30:02
 * @LastEditors: Json Chen
 * @LastEditTime: 2022-06-14 15:28:24
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelLegal/LegalPageList/index.tsx
 */
import { SizeFittingTable } from '@/src/components/Antd';
import NoPermission from '@/src/components/NoPermission';
import SalesChannelSelection from '@/src/constrains/SalesChannelSelection';
import {
  isUserValid,
  salesChannelResourceNameGenerator,
} from '@/src/tools/getUserInfo';
import {
  EPermissionSource,
  EnumCategory,
  EnumOperation,
  EnumSubCategory,
} from '@/src/types/common/resources';
import moment from 'moment';
import React from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { MidTitle } from 'src/components/EditableTable/EditableTable';
import { handleClick } from 'src/constrains/CreateButtonWithLanguageChangeWarning/tools';
import Action from 'src/pages/SalesCannelVersion/SalesChannelLegal/Components/Action';
import Add from 'src/pages/SalesCannelVersion/SalesChannelLegal/Components/AddOverlay';
import Layout from 'src/pages/SalesCannelVersion/SalesChannelLegal/Components/TableListPageLayout';
import { generateList } from 'src/pages/SalesCannelVersion/SalesChannelLegal/tools';
import {
  duplicateLegalPages,
  getLegalPages,
} from 'src/request/salesChannel/legal';
//import { msg } from 'src/tools/message';
import { useI18n } from 'src/hooks/useRouterChange';
import { NEW } from 'src/tools/constant';
// import { formatDate1 } from 'src/tools/helper';
import {
  i18nGet,
  handleOnGetCurrentSCTimezoneUTC,
  handleOnFormatCurrentSCTimeAndDateWithTimezone,
} from 'src/tools/tools';
import LegalPageSelection from './LegalPageSelection';
import css from './css.module.less';

const permissions = (uuid: string) => {
  const view_all_legal_page_listing_page = isUserValid({
    source: EPermissionSource.salesChannel,
    resourcesGroup: [
      salesChannelResourceNameGenerator({
        category: EnumCategory.SalesChannelLegal,
        subCategory: EnumSubCategory.ChannelLegal,
        operation: EnumOperation.view_all_legal_page_listing_page,
        uuid,
      }),
    ],
  });
  const view_legal_page_details = isUserValid({
    source: EPermissionSource.salesChannel,
    resourcesGroup: [
      salesChannelResourceNameGenerator({
        category: EnumCategory.SalesChannelLegal,
        subCategory: EnumSubCategory.ChannelLegal,
        operation: EnumOperation.view_legal_page_details,
        uuid,
      }),
    ],
  });
  const add_edit_legal_page = isUserValid({
    source: EPermissionSource.salesChannel,
    resourcesGroup: [
      salesChannelResourceNameGenerator({
        category: EnumCategory.SalesChannelLegal,
        subCategory: EnumSubCategory.ChannelLegal,
        operation: EnumOperation.add_edit_legal_page,
        uuid,
      }),
    ],
  });
  const archive_legal_page = isUserValid({
    source: EPermissionSource.salesChannel,
    resourcesGroup: [
      salesChannelResourceNameGenerator({
        category: EnumCategory.SalesChannelLegal,
        subCategory: EnumSubCategory.ChannelLegal,
        operation: EnumOperation.archive_legal_page,
        uuid,
      }),
    ],
  });
  return {
    view_all_legal_page_listing_page,
    view_legal_page_details,
    add_edit_legal_page,
    archive_legal_page,
  };
};

const LegalPageList = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const scTimezoneUTC = handleOnGetCurrentSCTimezoneUTC();
  const [pages, setPages] = React.useState([]);
  const [salesChannelSelectVisible, setSalesChannelSelectVisible] =
    React.useState(false);
  const [legalPagesSelectVisible, setLegalPagesSelectVisible] =
    React.useState(false);
  const [selectedSalesChannel, setSelectedSalesChannel] = React.useState([]);
  const _s = (selectedSalesChannel || [])[0];
  const [basic, setBasic] = React.useState({
    salesChannelName: '',
    salesChannelUuid: null,
    timezoneInGmt: '',
  });
  const [search, setSearch] = React.useState('');
  const _p: { uuid: string } = useParams();
  const _h = useHistory();
  const { uuid } = _p;

  const {
    view_all_legal_page_listing_page,
    view_legal_page_details,
    add_edit_legal_page,
  } = permissions(uuid);

  const getPages = () => {
    getLegalPages(uuid).then((res: any) => {
      const { salesChannelName, salesChannelUuid, timezoneInGmt, summaryList } =
        res || {};
      setPages(summaryList || []);
      setBasic({
        salesChannelName,
        salesChannelUuid,
        timezoneInGmt,
      });
    });
  };
  React.useEffect(() => {
    if (view_all_legal_page_listing_page) {
      getPages();
    }
  }, []);

  const addNew = (pageUuid) => {
    handleClick({
      onClick: () => {
        _h.push(
          `/salesChannel/legalPage/editor/${uuid}/${pageUuid}?index=${
            pages.length + 1
          }`,
        );
      },
      title: getI18n('legalPage.index.createLegalPage'),
      content: getI18n('legalPage.index.createLegalPageContent'),
      onOkText: getI18n('general.antd.Uploader.ok'),
      onCancelText: getI18n('general.cancel'),
      salesChannelUuid: uuid,
    });
  };

  const addButtonMenu = [
    {
      key: 'add',
      name: getI18n('legalPage.index.createNewLegalPages'),
      description: getI18n('legalPage.index.createNewLegalPagesDesc'),
      type: 'Add',
      onClick: () => {
        addNew(NEW);
      },
    },
    {
      key: 'duplicate',
      name: getI18n('legalPage.index.duplicateFromOtherLegalPages'),
      description: getI18n('legalPage.index.duplicateFromOtherLegalPagesDesc'),
      type: 'Duplicate',
      onClick: () => {
        setSelectedSalesChannel([]);
        setSalesChannelSelectVisible(true);
      },
    },
  ];

  // const handleOnDelete = (uuid) => {
  //   deleteLegalPage(uuid).then((res) => {
  //     const _pages = pages.filter((i) => i.uuid !== uuid);

  //     setPages(_pages);
  //     msg.success('legal page has been deleted');
  //   });
  // };

  const jump = (pageUuid) => {
    _h.push(
      `/salesChannel/legalPage/editor/${uuid}/${pageUuid}?index=${
        pages.length + 1
      }`,
    );
  };

  const handleOnEdit = (uuid) => {
    jump(uuid);
  };

  const columns = [
    {
      title: getI18n('general.pageName'),
      dataIndex: 'name',
      default: true,
      minWidth: 280,
      sorter: (a, b) => a.name.localeCompare(b.name),
    },
    {
      title: getI18n('legalPage.index.versionRemarks'),
      dataIndex: 'remarks',
      default: true,
      minWidth: 190,
      sorter: (a, b) => a.remarks.localeCompare(b.remarks),
    },
    {
      title: `${getI18n('general.created')} (UTC ${scTimezoneUTC})`,
      default: true,
      minWidth: 130,
      sorter: (a, b) => {
        return moment(a.createdDate || null).isBefore(
          moment(b.createdDate || null),
        )
          ? -1
          : 1;
      },
      childGenerate: (text, record) => {
        const { createdDate } = record;
        return handleOnFormatCurrentSCTimeAndDateWithTimezone(createdDate);
      },
    },
    {
      title: `${getI18n('general.lastModified')} (UTC ${scTimezoneUTC})`,
      default: true,
      minWidth: 130,
      childGenerate: (text, record) => {
        const { modifiedDate } = record;
        return handleOnFormatCurrentSCTimeAndDateWithTimezone(modifiedDate);
      },
      sorter: (a, b) => {
        return moment(a.modifiedDate || null).isBefore(
          moment(b.modifiedDate || null),
        )
          ? -1
          : 1;
      },
    },

    !view_legal_page_details
      ? {}
      : {
          titleGenerate: () => {
            return (
              <MidTitle>
                <span>
                  {getI18n(
                    'general.advancedFilters.commonStoreProductsWithTable.actions',
                  )}
                </span>
              </MidTitle>
            );
          },
          minWidth: 140,
          default: true,
          childGenerate: (text, record) => {
            const { uuid } = record;
            return (
              <Action
                // onDelete={handleOnDelete.bind(this, uuid)}
                onEdit={handleOnEdit.bind(this, uuid)}
              />
            );
          },
        },
  ];

  const data = generateList({ data: pages, search });

  const breadcrumbData = [
    {
      url: '/',
      name: getI18n('general.sider.home'),
    },
    {
      url: '/salesChannel',
      name: basic.salesChannelName,
    },
    {
      url: '',
      name: getI18n('legalPage.index.legalPages'),
    },
  ];

  //const add = <Add addButtonMenu={addButtonMenu} />;
  const handleOnSalesChannelCancel = () => {
    setSelectedSalesChannel([]);
    setSalesChannelSelectVisible(false);
  };

  const handleOnSalesChannelConfirm = (uuids: string[]) => {
    setSelectedSalesChannel(uuids);
    setSalesChannelSelectVisible(false);
    setLegalPagesSelectVisible(true);
  };

  const handleOnLegalSelectionCancel = () => {
    setSelectedSalesChannel([]);
    setLegalPagesSelectVisible(false);
    // setSalesChannelSelectVisible(true);
  };

  const handleOnLegalSelectionBack = () => {
    setLegalPagesSelectVisible(false);
    setSalesChannelSelectVisible(true);
  };

  const handleOnLegalSelectionConfirm = (salesChannelUuid, legalPagesUuid) => {
    duplicateLegalPages(uuid, legalPagesUuid).then((res) => {
      getPages();
      handleOnLegalSelectionCancel();
    });
  };

  return view_all_legal_page_listing_page ? (
    <Layout
      disableAdd={!add_edit_legal_page}
      addButtonOverlay={
        <Add
          addButtonMenu={addButtonMenu}
          title={getI18n('legalPage.index.addLegalPage')}
        />
      }
      breadcrumbData={breadcrumbData}
      onSearch={setSearch}
      title={getI18n('legalPage.index.allLegalPages')}
      addText={getI18n('legalPage.index.addLegalPage')}
      addFun={addNew.bind(this, NEW)}>
      {salesChannelSelectVisible && (
        <SalesChannelSelection
          selectedItems={selectedSalesChannel || []}
          onOk={handleOnSalesChannelConfirm}
          onCancel={handleOnSalesChannelCancel}
          visible={salesChannelSelectVisible}
        />
      )}
      {legalPagesSelectVisible && _s && (
        <LegalPageSelection
          visible={legalPagesSelectVisible && _s}
          onCancel={handleOnLegalSelectionCancel}
          onOk={handleOnLegalSelectionConfirm}
          salesChannelUuid={_s}
          onBack={handleOnLegalSelectionBack}
        />
      )}
      <SizeFittingTable
        id='salesChannelLegalPageList'
        rowKey={'uuid'}
        //className={styles.table}
        dataSource={data}
        pagination={false}
        columns={columns}
        className={css.table}
      />
    </Layout>
  ) : (
    <NoPermission />
  );
};
export default LegalPageList;
